"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSlotDurationMin = exports.DefaultTimezone = void 0;
exports.DefaultTimezone = 'Europe/Berlin';
exports.DefaultSlotDurationMin = 15;
//# sourceMappingURL=defaults.js.map